import { Quote } from 'ui/components';

export const QuoteFeature: React.FC<Umbraco.Quote> = ({ content }) => {
	return <Quote {...content?.properties} />;
};
